// extracted by mini-css-extract-plugin
export var container = "_gb-0";
export var infoIcon = "_gb-2";
export var titleRowCol = "_gb-1";